export const MAX_TEMPLATE_BUTTONS = 10;
export const MAX_BUTTON_LABEL_LENGTH = 40;
export const BUTTON_TYPE_LIMITS = Object.freeze({
  reply: 10,
  url: 2,
  phone: 1,
  payment_method: 1,
});

export const getButtonTypeCount = (buttons, type) =>
  buttons.filter(button => button.type === type).length;

export const canAddButtonType = (buttons, type, index = -1) => {
  const count = buttons.filter(
    (button, buttonIndex) => button.type === type && buttonIndex !== index
  ).length;
  return count < BUTTON_TYPE_LIMITS[type];
};

const getButtonTypeLabelKey = type => {
  if (type === 'url') return 'ACTIVE_MESSAGES.BUTTON_TYPES.LINKS';
  if (type === 'phone') return 'ACTIVE_MESSAGES.BUTTON_TYPES.PHONES';
  return 'ACTIVE_MESSAGES.BUTTON_TYPES.REPLIES';
};

export const validateTemplateButtons = (format, buttons, t = key => key) => {
  const errors = [];
  if (!buttons.length) return [t('ACTIVE_MESSAGES.BUTTON_ERRORS.EMPTY')];
  if (buttons.length > MAX_TEMPLATE_BUTTONS) {
    errors.push(t('ACTIVE_MESSAGES.BUTTON_ERRORS.MAX_BUTTONS'));
  }

  const allowedTypes =
    format === 'quick_replies'
      ? ['reply']
      : ['reply', 'url', 'phone', 'payment_method'];
  if (buttons.some(button => !allowedTypes.includes(button.type))) {
    errors.push(
      format === 'quick_replies'
        ? t('ACTIVE_MESSAGES.BUTTON_ERRORS.QUICK_REPLIES_ONLY')
        : t('ACTIVE_MESSAGES.BUTTON_ERRORS.ALLOWED_TYPES')
    );
  }

  Object.entries(BUTTON_TYPE_LIMITS).forEach(([type, limit]) => {
    if (getButtonTypeCount(buttons, type) > limit) {
      errors.push(
        t('ACTIVE_MESSAGES.BUTTON_ERRORS.TYPE_LIMIT', {
          limit,
          // Button types are restricted to BUTTON_TYPE_LIMITS.
          // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
          type: t(getButtonTypeLabelKey(type)),
        })
      );
    }
  });

  if (
    buttons.some(
      button => (button.label || '').trim().length > MAX_BUTTON_LABEL_LENGTH
    )
  ) {
    errors.push(t('ACTIVE_MESSAGES.BUTTON_ERRORS.LABEL_TOO_LONG'));
  }

  return errors;
};
